import { useEffect, useState, type FormEvent } from 'react';
import * as api from '../lib/api';

/**
 * Instructor sign-in. One shared password, as agreed — there are no accounts,
 * so there is no username field and nothing to look up.
 */
export function SignIn({ onSignedIn }: { onSignedIn: () => void }) {
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [configured, setConfigured] = useState<boolean | null>(null);

  // Asked up front so a fresh deployment says "no password has been set" rather
  // than letting someone guess at a password that does not exist yet.
  useEffect(() => {
    api
      .health()
      .then((h) => setConfigured(h.configured))
      .catch(() => setConfigured(null));
  }, []);

  async function submit(e: FormEvent) {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      api.saveToken(await api.login(password));
      onSignedIn();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Sign-in failed.');
      setPassword('');
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="signin">
      <form className="signin__card" onSubmit={submit}>
        <div>
          <p className="eyebrow">Instructor</p>
          <h1 style={{ fontSize: 36, marginTop: 'var(--s-2)' }}>Examatron™</h1>
        </div>

        {configured === false && (
          <div className="notice notice--bad">
            No instructor password has been set yet. Run{' '}
            <code>node scripts/set-admin-password.mjs</code> and reload.
          </div>
        )}

        <div className="field">
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            autoFocus
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </div>

        {error && <div className="notice notice--bad">{error}</div>}

        <button className="btn" type="submit" disabled={busy || !password}>
          {busy ? 'Checking…' : 'Sign in'}
        </button>
      </form>
    </div>
  );
}
